/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Discard_TitleInputs */

const cs_form_discard_title = /** @type {(inputs: Form_Discard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuložené změny`)
};

const en_form_discard_title = /** @type {(inputs: Form_Discard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsaved changes`)
};

/**
* | output |
* | --- |
* | "Unsaved changes" |
*
* @param {Form_Discard_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_discard_title = /** @type {((inputs?: Form_Discard_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Discard_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_discard_title(inputs)
	return cs_form_discard_title(inputs)
});